import { render, staticRenderFns } from "./PopularSearchBlock.vue?vue&type=template&id=134f712a&"
import script from "./PopularSearchBlock.vue?vue&type=script&lang=js&"
export * from "./PopularSearchBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports